import $ from 'jquery';
import {__} from "../libraries/translations.ts";

const moment = require('moment');

export class DatePicker {

    component;
    visibleComponent;
    value;
    valueChanges;
    values = {
        year: -1,
        month: -1,
        day: -1
    };
    selectors = {
        year: null,
        month: null,
        day: null
    };
    inOutFormat = 'DD-MM-YYYY';

    constructor(component) {
        this.component = component;
        this.initReadValue();
        this.createComponent();
    }

    onChange(valueChanges) {
        this.valueChanges = valueChanges;
        return this;
    }

    initReadValue() {
        const val = moment($(this.component).val(), this.inOutFormat);
        if(val.isValid()) {
            this.values.day = val.date();
            this.values.month = val.month();
            this.values.year = val.year();
        }
    }

    createComponent() {
        const baseHtml = '<div class="input-group">\n' +
            '            <select class="form-select day">\n' +
            '                <option selected disabled value="-1">Dag</option>\n' +
            '            </select>\n' +
            '            <select class="form-select month">\n' +
            '                <option selected disabled value="-1">Maand</option>\n' +
            '            </select>\n' +
            '            <select class="form-select year">\n' +
            '                <option selected disabled value="-1">Jaar</option>\n' +
            '            </select>\n' +
            '        </div>';

        const now = new Date();
        this.visibleComponent = $(baseHtml).insertAfter(this.component);

        this.fill('month', __('daterangepicker.monthNames'));
        this.fill('day', this.getNumbersAsc(0, 31), true);
        this.fill('year', this.getNumbersDesc(now.getFullYear() + 1, now.getFullYear() - 100), true);


        $(this.component).hide();

    }

    fill(className, items, useValues = false) {
        const el = this.visibleComponent.find('.' + className);
        for (let index in items) {
            const val = useValues ? items[index] : (+index);
            el.append(`<option value="${val}">${items[index]}</option>`);
        }
        this.selectors[className] = el;
        el.on('change', event => {
            this.values[className] = el.val();
            this.processValueChanged();
        })
        el.val(this.values[className]);
    }

    getNumbersAsc(start, end) {
        const numbers = [];
        for (let i = start; i < end; i++) {
            numbers.push(i + 1);
        }
        return numbers;
    }

    getNumbersDesc(start, end) {
        const numbers = [];
        for (let i = start; i >= end; i--) {
            numbers.push(i);
        }
        return numbers;
    }

    processValueChanged() {
        if (this.values.day > 0 && this.values.month >= 0 && this.values.year > 0) {
            // try to construct date
            const date = new Date(+this.values.year, +this.values.month, +this.values.day);
            if (date.getMonth() !== +this.values.month) {
                // invalid date!
                this.selectors.day.val(-1);
                this.values.day = null;
                this.value = null;
                $(this.component).val('');
                return;
            }

            this.value = date;
            const formatted = moment(date).format(this.inOutFormat);
            $(this.component).val(formatted);

            if(this.valueChanges) {
                console.log('valid date', this.value, this.values);
                this.valueChanges(this.value);
            }
        }
    }
}
